import { Axios } from '../axios'

const createAnnouncement = async (payload) => {
  const { data } = await Axios.post('/announcements/create', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,
  })
  return data
}

const getAnnouncements = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''

  const { data } = await Axios.get(
    `/announcements?limit=${payload.limit}&page=${payload.page}${search}`
  )

  return data?.data
}

const getScheduledAnnouncements = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''

  const { data } = await Axios.get(
    `/announcements/unpublish?limit=${payload.limit}&page=${payload.page}${search}`
  )

  return data?.data
}

const deleteAnnouncement = async (payload) => {
  const { data } = await Axios.delete('/announcements/' + payload)
  return data
}

const getSingleAnnouncement = async (payload) => {
  const { data } = await Axios.get('/announcements/' + payload)
  return data?.data
}

const addAnnouncementComment = async (payload) => {
  const { data } = await Axios.post(
    `/announcements/${payload.id}/comment`,
    payload.data
  )
  return data
}

const publishAnnouncement = async (payload) => {
  const { data } = await Axios.put(`/announcements/${payload.id}/publish`)
  return data
}

const deleteComment = async (payload) => {
  const { data } = await Axios.delete('/announcements/comment/' + payload)
  return data
}


const updateAnnouncement = async (payload) => {
  const { data } = await Axios.post(
    `/announcements/${payload.id}`,
    payload.data
  )
  return data
}


export const announcements = {
  createAnnouncement,
  getAnnouncements,
  getScheduledAnnouncements,
  deleteAnnouncement,
  getSingleAnnouncement,
  addAnnouncementComment,
  publishAnnouncement,
  deleteComment,
  updateAnnouncement,
}
